import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Row
} from 'shards-react';
import SelectInput from '../../common/form/SelectInput';
import TextAreaInput from '../../common/form/TextAreaInput';
import TextInput from '../../common/form/TextInput';
import { sendBugReport } from './bugReportActions';

const mapState = (state, ownProps) => ({
  profile: state.firebase.profile,
  loading: state.async.loading
});

const actions = {
  sendBugReport
};

const validate = combineValidators({
  page: isRequired('page'),
  message: isRequired('report')
});
class BugReport extends Component {
  render() {
    const { submitting, pristine, handleSubmit } = this.props;
    return (
      <Container>
        <Card small className='my-3'>
          <CardHeader className='border-bottom d-flex justify-content-between bg-primary1'>
            <h5 className='m-0'>Bug Report Form</h5>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit(sendBugReport)}>
              <Row form>
                <Col>
                  <FormGroup>
                    <label htmlFor='page'>Page/Section</label>
                    <Field
                      component={TextInput}
                      type='text'
                      name='page'
                      placeholder={'E.g. Contact Form, Complaint Dashboard'}
                    />
                  </FormGroup>
                </Col>

                <Col className='form-group'>
                  <FormGroup>
                    <label htmlFor='type'>Type</label>
                    <Field
                      component={SelectInput}
                      type='select'
                      name='type'
                      placeholder={''}
                      options={[
                        { label: 'Link/Button broken', value: 'link_broken' },
                        { label: 'Missing Information', value: 'missing_info' },
                        { label: 'Others', value: 'others' }
                      ]}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col>
                  <FormGroup>
                    <label htmlFor='message'>Message</label>
                    <Field
                      component={TextAreaInput}
                      type='textarea'
                      name='message'
                      placeholder={
                        ' E.g. I could not click Submit button in the Add Complaint form'
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className='home-buttons d-flex w-100 justify-content-between'>
                <Button
                  type='submit'
                  theme='success'
                  disabled={submitting || pristine}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'bugReportForm', validate })
)(BugReport);
